import { api } from "@/lib/utils";

export { sendEmailWithQRCode };

async function sendEmailWithQRCode({
  email,
  QRCodeUrl,
  companyName,
  type,
}: {
  email: string;
  QRCodeUrl: string;
  companyName: string;
  type: string;
}) {
  const response = await api.post("/api/qr", {
    email,
    QRCodeUrl,
    companyName,
    type,
  });
  return response.data;
}
